export const AUTH_STORAGE_KEY = 'session_token';
export const LEGACY_AUTH_STORAGE_KEY = 'pi_session_token';
export const GAME_TOKEN_STORAGE_KEY = 'game_token';

export function getSessionToken(): string | null {
  return localStorage.getItem(AUTH_STORAGE_KEY) ?? localStorage.getItem(LEGACY_AUTH_STORAGE_KEY);
}

export function setSessionToken(token: string): void {
  localStorage.setItem(AUTH_STORAGE_KEY, token);
}

/**
 * Game token — HMAC-signed JWT for MicroK8s services.
 * Verified locally by Colyseus (no CF Worker round-trip).
 */
export function getGameToken(): string | null {
  return localStorage.getItem(GAME_TOKEN_STORAGE_KEY);
}

export function setGameToken(token: string): void {
  localStorage.setItem(GAME_TOKEN_STORAGE_KEY, token);
}

export function removeSessionToken(): void {
  localStorage.removeItem(AUTH_STORAGE_KEY);
  localStorage.removeItem(LEGACY_AUTH_STORAGE_KEY);
  localStorage.removeItem(GAME_TOKEN_STORAGE_KEY);
  localStorage.removeItem('session_token_expires_at');
}

export function isAuthenticated(): boolean {
  return Boolean(getSessionToken());
}

export function redirectToLogin(path: string = '/'): void {
  removeSessionToken();
  window.location.href = path;
}
